import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { buildWaLink, GENERAL_MESSAGE, trackWhatsApp } from "@/lib/services";

export default function StickyContact() {
  // Mobile sticky bottom bar — two equal buttons.
  return (
    <div data-testid="sticky-contact-dock" className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 backdrop-blur shadow-soft">
      <div className="grid grid-cols-2">
        <a
          data-testid="sticky-call"
          href={`tel:${BRAND.phoneTel}`}
          className="flex items-center justify-center gap-2 py-4 text-navy font-semibold border-r border-navy/10"
          style={{ minHeight: 56 }}
        >
          <Phone className="w-5 h-5" /> Call Now
        </a>
        <a
          data-testid="sticky-whatsapp"
          href={buildWaLink(GENERAL_MESSAGE)}
          target="_blank" rel="noopener noreferrer"
          onClick={() => trackWhatsApp("Sticky Bar WhatsApp")}
          className="flex items-center justify-center gap-2 py-4 text-white font-semibold"
          style={{ minHeight: 56, backgroundColor: "#25D366" }}
        >
          <MessageCircle className="w-5 h-5" /> WhatsApp
        </a>
      </div>
    </div>
  );
}
